import { useStore } from '@app/store/useStore.hook';
import { ECustomerGen, EPlanType } from '@app/swagger-types';
import { useActivePlan } from './useActivePlan';

export const usePlanLimits = () => {
  const currentUser = useStore.useCurrentUser();
  const planDetails = currentUser?.currentPlanDetails;

  const { isExpired, isTrialExpired } = useActivePlan();

  const noDispute = !planDetails?.hasDisputedPayment;
  const isFreeUser = planDetails?.planType === EPlanType.FREE;
  const isBusinessOrOldUser = planDetails?.planType === EPlanType.BUSINESS || currentUser?.isOldPlanUser;
  const isGen5Plus = !(
    currentUser?.customerGen === ECustomerGen.GEN4 ||
    currentUser?.customerGen === ECustomerGen.GEN3 ||
    currentUser?.customerGen === ECustomerGen.GEN2 ||
    currentUser?.customerGen === ECustomerGen.GEN1
  );

  if (isExpired || isTrialExpired) {
    return {
      allLimits: planDetails,
      currentUser,
      canCreateQRCode: false,
      canCreateTemplate: false,
      canDownloadSVG: false,
      canEditQrInput: false,
      canSeeAnalyticsUpTo6Months: false,
      canSeeAnalyticsForYear: false,
      canCreateBulk: false,
      canTrackGPS: false,
      canUseAPIKeys: false,
      canUseWhiteLabel: false,
      canUseQRSettings: false,
      canUseSubdomain: false,
      canUseTeam: false,
    };
  }

  return {
    allLimits: planDetails,
    currentUser,
    canCreateQRCode:
      noDispute &&
      (planDetails?.amountMaxQrCodes === null ||
        checkIsFirstNumberLess(currentUser?.totalCodes, planDetails?.amountMaxQrCodes)),
    canCreateTemplate: noDispute && planDetails?.hasTemplates,
    canDownloadSVG: planDetails?.fileExtensions?.includes('SVG') || currentUser?.isOldPlanUser || false,
    canEditQrInput: !isFreeUser,
    canSeeAnalyticsUpTo6Months: !isFreeUser,
    canSeeAnalyticsForYear: isBusinessOrOldUser,
    canCreateBulk: planDetails?.hasBulkQrCodeGeneration || false,
    canTrackGPS: isGen5Plus ? planDetails?.hasTrackScanGPS : isBusinessOrOldUser,
    canUseAPIKeys: isGen5Plus ? planDetails?.hasApiKey : isBusinessOrOldUser,
    canUseWhiteLabel: isGen5Plus ? planDetails?.hasWhiteLabel : isBusinessOrOldUser,
    canUseQRSettings: isGen5Plus ? planDetails?.hasQrDesignCustomisations : isBusinessOrOldUser,
    canUseSubdomain: isGen5Plus ? planDetails?.hasWhiteLabel : isBusinessOrOldUser,
    canUseTeam: planDetails?.hasTeamAccess,
    // TODO when API ready
    // canEditQrInput: planDetails?.hasQrAdjustableInput || false,
  };
};

const checkIsFirstNumberLess = (first?: number, second?: number) => {
  if (typeof first !== 'number' || typeof second !== 'number') {
    return;
  }
  return first < second;
};
